import formMainHubConfig from './formMainHubConfig';
import formConfigLanguage from './formConfigLanguage';
import formGroupAppClientRecommendations from './formGroupAppClientRecommendations';
import formGroupAppClientSpaces from './formGroupAppClientSpaces';

export default {
  title: 'White Label Pro Config Form',
  attributeName: 'mhConfigs',
  getURL: 'mainHubs/mainHubId/mainHubConfig/show',
  createURL: 'mainHubs/mainHubId/mainHubConfig',
  updateURL: 'mainHubs/mainHubId/mainHubConfig',
  autoUpdate: false,
  idAttribute: 'id',
  idUpdate:true,
  noUpdateWithId: true,
  sessionParams: ['mainHubId'],
  formConfig: [formMainHubConfig, formConfigLanguage, formGroupAppClientRecommendations,formGroupAppClientSpaces],
  formGroupExpands: false,
  noArea: true,
  goBack: false,
};
